import React, { useCallback, useState } from 'react';

import { X } from 'phosphor-react';

import { CloseBtn, Container, ModalAlertContainer, ModalHome, Poster } from './styles';
import { API_S3 } from '../../services/api_s3';

interface IModalSignatueExpiresProps {
  setModalSignatueExpiresIsOpen: (value: boolean) => void;
}

const ModalSignatueExpires: React.FC<IModalSignatueExpiresProps> = ({ setModalSignatueExpiresIsOpen }) => {
  const [openModal, setOpenModal] = useState(true);

  const handleCloseModal = useCallback(() => {
    setOpenModal(false);
    setModalSignatueExpiresIsOpen(false);
  }, [setOpenModal, setModalSignatueExpiresIsOpen]);

  return (
    <Container>
      <ModalHome
        onRequestClose={handleCloseModal}
        isOpen={openModal}
        shouldCloseOnOverlayClick
        shouldCloseOnEsc
        closeTimeoutMS={300}
        overlayClassName="react-modal-overlay"
      >
        <ModalAlertContainer>
          <Poster>
            <CloseBtn onClick={handleCloseModal}><X weight="bold" /></CloseBtn>

            <a href="https://professorgabrielcabral.com.br" target="_blank" rel="noreferrer">
              <img src={`${API_S3}/default/estender-plano.webp`} alt="Estender Plano" />
            </a>
          </Poster>
        </ModalAlertContainer>
      </ModalHome>
    </Container>
  );
}

export default ModalSignatueExpires;